import '../Content/css/basic_en.less'
import '../Content/css/air_grid.less'
import '../Content/css/page_en.css'
import '../Content/css/products.less'
//var leftnav = document.getElementById("#LeftNav");

//addLoadEvent(ProductNav);

window.addEventListener('load', function() {
	var leftnav = $(".leftnav"),
		product = $(".index-product"),
		breadcrumb = $(".breadcrumb-nav"),
		header = $("#header"),
		index_product = $(".index-product"),
		index_product_bottom = parseInt(index_product.css('margin-bottom')),
		height_header = breadcrumb[0].offsetHeight + header[0].offsetHeight;

	function getScrollTop() { //取得滚动条的竖直距离
		return document.documentElement.scrollTop || document.body.scrollTop;
	}

	function setscrollTop(val) {
		document.body.scrollTop = val;
		document.documentElement.scrollTop = val;
	}

	function ProductNav() {
		leftnav.on('click', function() {
			leftnav.removeClass("active");
			$(this).addClass("active");
			var i = leftnav.index(this),
				b = 0,
				scrolltop;
			if(i === 0) {
				scrolltop = height_header;
			} else {
				for(var num = 0; num < i; num++) {
					b += product[num].offsetHeight + index_product_bottom;
				}
				scrolltop = b + height_header;
			}
			setscrollTop(scrolltop);
		})
	}

	function ScrollListen() {
		for(var num = 0; num < product.length; num++) {
			var product_top = product[num].getBoundingClientRect().top;
			var leftnav_class = leftnav[num].getAttribute('class');
			if(product_top > 0 && product_top < document.documentElement.clientHeight / 2) {
				leftnav.removeClass('active');
				leftnav[num].setAttribute('class', 'leftnav active');
			}
		}
	}

	function ScrollTop() {
		var scrolltop = getScrollTop();
		if(scrolltop >= height_header) {
			$("#LeftNav").addClass("active");
		} else {
			$("#LeftNav").removeClass("active");
		}
	}
	ProductNav();
	ScrollTop();

	if(window.innerWidth > 768) {
		window.onscroll = function() {
			ScrollTop();
			ScrollListen();
		}
	}
	$("#left_nav_button").on('click', function() {
		$("#LeftNav").addClass("active").removeClass("close")
	});
	$(".close_button").on('click', function() {
		$("#LeftNav").removeClass("active").addClass("close");
	});
});


// WEBPACK FOOTER //
// ./E:/airwheel.net/entry/products.js